/**
 * AfterpayInline — subtle "or 4 × $X with Afterpay" line for treatment cards.
 *
 * Drops in under any price display to remove sticker-shock and lift
 * conversion. Only renders when the price is within Afterpay's normal
 * consumer range ($50 – $2000) so we never mislead clients about a
 * treatment they can't actually finance.
 *
 * Usage:
 *   <AfterpayInline price={399} />                      // → or 4 × $99.75 with Afterpay
 *   <AfterpayInline price="$1,199" />                   // string form OK
 *   <AfterpayInline price={399} size="sm" align="left" />
 */

const parsePrice = (input) => {
  if (typeof input === "number") return isFinite(input) ? input : null;
  if (!input && input !== 0) return null;
  const cleaned = String(input).replace(/[^0-9.]/g, "");
  const n = parseFloat(cleaned);
  return isFinite(n) ? n : null;
};

const AfterpayInline = ({ price, size = "sm", align = "left", tone = "auto", className = "" }) => {
  const amt = parsePrice(price);
  if (amt == null || amt < 50 || amt > 2000) return null;
  const per = (amt / 4).toFixed(2);

  const sizeClass = size === "xs" ? "text-[10.5px]" : size === "md" ? "text-sm" : "text-[11.5px]";
  const alignClass = align === "center" ? "justify-center" : align === "right" ? "justify-end" : "justify-start";
  const toneClass =
    tone === "dark"
      ? "text-zinc-300"
      : tone === "light"
      ? "text-zinc-600"
      : "text-zinc-500 dark:text-zinc-400";

  return (
    <div
      className={`inline-flex items-center gap-1.5 ${sizeClass} ${toneClass} ${alignClass} ${className}`}
      data-testid="afterpay-inline"
      aria-label={`Or 4 payments of $${per} with Afterpay`}
    >
      <span className="tracking-tight">or</span>
      <span className="font-semibold text-zinc-800 dark:text-zinc-100">
        4 × ${per}
      </span>
      <span>with</span>
      <span
        className="inline-flex items-center px-1.5 py-[1px] rounded-md font-bold tracking-tight"
        style={{
          background: "#b2fce4",
          color: "#0a1a12",
          fontFeatureSettings: '"ss01"',
        }}
      >
        afterpay
      </span>
    </div>
  );
};

export default AfterpayInline;
